export default (itemId, locationId, zoneId) =>
  zoneId ? `${itemId}_${locationId}_${zoneId}` : `${itemId}_${locationId}`;
